import $ from "jquery";
import select2 from 'select2';

export default class ArchiveFilterSelectHandler {

    constructor() {
        select2($);
        $('.sm-sort-box').select2({
            minimumResultsForSearch:    Infinity,
            dropdownParent:             $('.archive-filter__select'),
            dropdownCssClass:           'custom-select',
            selectionCssClass:          'custom-select__selected',
        });
    };
}